import { FaCaretLeft, FaCaretRight } from 'react-icons/fa';

const ENTRIES_PER_PAGE = 9;

interface StickyNotesPaginationProps {
  page: number;
  count: number;
  onPageClick: (page: number) => void;
}

function getPageItems(current: number, total: number): (number | '…')[] {
  if (total <= 9) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }

  const items: (number | '…')[] = [1];
  const start = Math.max(2, current - 2);
  const end = Math.min(total - 1, current + 2);

  if (start > 2) items.push('…');
  for (let p = start; p <= end; p++) items.push(p);
  if (end < total - 1) items.push('…');
  items.push(total);
  return items;
}

const StickyNotesPagination: React.FC<StickyNotesPaginationProps> = ({
  page,
  count,
  onPageClick
}) => {
  const totalPages = count > 0 ? Math.ceil(count / ENTRIES_PER_PAGE) : 0;
  if (totalPages <= 1) return null;

  const items = getPageItems(page, totalPages);

  return (
    <nav
      className="sticky-notes-pagination"
      aria-label="Sticky Notes pagination"
    >
      <button
        type="button"
        className="sticky-notes-pagination-btn sticky-notes-pagination-arrow"
        disabled={page <= 1}
        onClick={() => onPageClick(page - 1)}
        aria-label="Previous page"
      >
        <FaCaretLeft size={22} aria-hidden="true" />
      </button>
      {items.map((item, index) =>
        item === '…' ? (
          <span
            key={`ellipsis-${index}`}
            className="sticky-notes-pagination-ellipsis"
            aria-hidden="true"
          >
            …
          </span>
        ) : (
          <button
            key={`page-${item}`}
            type="button"
            className={`sticky-notes-pagination-btn ${item === page ? 'is-active' : ''}`}
            onClick={() => onPageClick(item)}
            aria-label={`Page ${item}`}
            aria-current={item === page ? 'page' : undefined}
          >
            {item}
          </button>
        )
      )}
      <button
        type="button"
        className="sticky-notes-pagination-btn sticky-notes-pagination-arrow"
        disabled={page >= totalPages}
        onClick={() => onPageClick(page + 1)}
        aria-label="Next page"
      >
        <FaCaretRight size={22} aria-hidden="true" />
      </button>
    </nav>
  );
};

export default StickyNotesPagination;
